const initData = {
  data: [],
  isLoaded: false
}

export default initData